export default __webpack_public_path__ + "bug-reports.svg";